// extracted by mini-css-extract-plugin
module.exports = {"container":"_181hge9SW4CoQfIgBdWs1X","item":"_2g-VTxEuTlfdV5w9xybyO9","dot":"_1XFVGKFll1kh3IMai40Tw0","positionNumber":"PvMnDB4X1wa-YF57ieepZ"};